import { useCallback, useState } from 'react';
import { FileBrowserStorageObjectFragment } from '../../graphql/generated';

export type SelectedFilesState = Record<
  string, // id
  FileBrowserStorageObjectFragment
>;

export const useSelectedFiles = (
  allFiles: FileBrowserStorageObjectFragment[]
) => {
  const [selectedFiles, setSelectedFiles] = useState<SelectedFilesState>({});

  const toggleFileSelection = useCallback(
    (file: FileBrowserStorageObjectFragment) => {
      setSelectedFiles((prev) => {
        // If already selected, remove it. Otherwise, add it
        if (prev[file.id]) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { [file.id]: _, ...rest } = prev;
          return rest;
        } else {
          return { ...prev, [file.id]: file };
        }
      });
    },
    []
  );

  const selectAllFiles = () => {
    setSelectedFiles(
      allFiles.reduce((acc, file) => {
        if (file.__typename === 'File' && file.canMove) {
          acc[file.id] = file;
        }
        return acc;
      }, {} as SelectedFilesState)
    );
  };

  const clearAllFiles = () => setSelectedFiles({});

  return {
    selectedFiles,
    toggleFileSelection,
    selectAllFiles,
    clearAllFiles,
  };
};